import axios from "axios";
import {useQuery} from "@tanstack/vue-query";

const getCompetitors = () =>  useQuery({
  queryKey: ['backlink-competitors'],
  queryFn: async () => {
    const { data } = await axios.get('/ajax/v2/competitors');

    return data.data.filter((competitor) => !competitor.isWebsiteAsCompetitor);
  },
});


export {
  getCompetitors,
}
